import { isPrintPathname } from "@/lib/route-error-utils"

/**
 * Loop-guard decision for `vite:preloadError` auto-reload (stale hashed chunks after a deploy).
 * Pure logic — the sessionStorage/window wiring lives in `preload-error-listener.ts` (infra).
 */

export const PRELOAD_ERROR_RELOAD_KEY = "floorpilot:preload-error-reload"

/** Suppress repeat reloads of the SAME failure inside this window — one bad chunk must never
 * become an infinite refresh loop. A different message (new deploy, different chunk) still
 * gets its one reload. */
export const PRELOAD_ERROR_RELOAD_WINDOW_MS = 2 * 60 * 1000

/** What the listener stamps into sessionStorage just before reloading. */
export interface PreloadErrorReloadEntry {
	/** `error.message` of the failure that triggered the last reload (embeds the chunk URL). */
	message: string
	/** Epoch ms of that reload. */
	at: number
}

/** True when a reload is the right response to this preload failure. */
export function shouldReloadOnPreloadError(args: {
	pathname: string
	message: string
	now: number
	previous: PreloadErrorReloadEntry | null
}): boolean {
	// The headless PDF worker must never have its render restarted under it.
	if (isPrintPathname(args.pathname)) return false
	if (args.previous && args.previous.message === args.message && args.now - args.previous.at < PRELOAD_ERROR_RELOAD_WINDOW_MS) {
		return false
	}
	return true
}
